import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { evaluateRules, validateAddons } from './rules';
import { ShadowContent } from './ShadowContent';
import { usePromo } from './promoHook';

/*

Usage:

Payload is pulled from growthbook at this time. Location is where the promo will be placed on the page.
If we need additional locations add <Promos area="<Area>" page="<Page>" /> to the associated component.
See ConfirmationPage/index.js for examples.

"rule" uses "json-rules-engine". See https://www.npmjs.com/package/json-rules-engine
The redux state is fed into the engine and uses object-path notation to fetch the value.
https://www.npmjs.com/package/object-path

"content" will be the rendered output. Click tracking events are added using "data-click-track"
which will fire off a noflake event

Example payload

{
  "enabled": true,
  "location": {
    "area": "bottom",
    "page": "confirmation"
  },
  "content": "<div data-click-track='doordash' style='display:flex;'><a href='https://doordash.com' target='_blank' style='margin:auto'><img src='https://assets.narvar.com/retailers/narvarreturns/fonts/doordash_20240923142435.png' alt='doordash-promo' style='border:1px solid #ccc'></a></div>",
  "rule": {
    "conditions": {
      "any": [
        {
          "fact": "retailerSettings.locale.default",
          "operator": "equal",
          "value": "en_US"
        }
      ]
    },
    "event": {
      "type": "locale"
    }
  }
}


*/

export const PromosComponent = ({ area, page }) => {
  const [rulesEvaluated, setRulesEvaluated] = useState([]);
  const { promos, error, data } = usePromo();

  useEffect(() => {
    if (!promos || !promos.length) return;
    const filteredAddons = promos.filter(
      (promo) => promo?.enabled && promo?.location && promo?.content,
    );
    const validAddons = validateAddons({ filteredAddons, page, area });
    evaluateRules(validAddons).then((evaluated) => {
      setRulesEvaluated(evaluated);
    });
  }, [promos, area, page]);

  if (error) {
    console.error(error);
    return null;
  }

  if (!rulesEvaluated || !rulesEvaluated.length) return null;

  return rulesEvaluated.map((promo) => {
    const id = ['promo', promo.option, area, page].filter(Boolean).join('.');
    return <ShadowContent {...{ promo, id, key: id, data }} />;
  });
};

export const Promos = connect(({ addons: { addons = [] } }) => ({ addons }))(PromosComponent);
